<div *ngIf="dataLoaded" class="card card-custom gutter-b">
    <div class="card-header border-0">
        <div class="card-title">
            <h3 class="card-label m-0">View Task</h3>
            <span class="ml-3 label label-lg label-inline" [ngClass]="
                {'label-light-primary': taskData.status === 'new',
                'label-light-warning': taskData.status === 'in progress',
                'label-light-success': taskData.status === 'completed'}">
                {{taskData.status | titlecase}}
            </span>
        </div>
        <div class="card-toolbar">
            <button *ngIf="stageId !== undefined && isAllowedToEdit" type="button" class="btn-back mr-3"
                    routerLink="/projects/{{projectId}}/stage/{{stageId}}/view/{{taskId}}/edit">
                <span class="fas fa-pen"></span>
            </button>
            <button *ngIf="stageId === undefined && projectId !== undefined && isAllowedToEdit" type="button" class="btn-back mr-3"
                    routerLink="/projects/{{projectId}}/{{taskId}}/edit">
                <span class="fas fa-pen"></span>
            </button>
            <button *ngIf="projectId === undefined && isAllowedToEdit" type="button" class="btn-back mr-3"
                    routerLink="/tasks/{{taskId}}/edit">
                <span class="fas fa-pen"></span>
            </button>

            <button *ngIf="stageId !== undefined" type="button" class="btn-back"
                    routerLink="/projects/{{projectId}}/stage/{{stageId}}/view">
                <span class="fa fa-arrow-left"></span>
            </button>
            <button *ngIf="stageId === undefined && projectId !== undefined" type="button" class="btn-back"
                    routerLink="/projects/{{projectId}}">
                <span class="fa fa-arrow-left"></span>
            </button>
            <button *ngIf="projectId === undefined" type="button" class="btn-back"
                    routerLink="/tasks">
                <span class="fa fa-arrow-left"></span>
            </button>
        </div>
    </div>

    <div class="card-body">
        <div class="row">

            <div class="col-12 col-xl-4 main-column">
                <div class="row h-100">
                    <!--Task Name-->
                    <div class="col-12 mb-8 top-tile">
                        <!--Taskuri venite din tasks module-->
                        <h3 *ngIf="projectId === undefined" class="form-label mb-8">
                            <ng-container *ngIf="projectDataLoaded">
                                {{ projectData.projectName | titlecase }}

                                <div class="d-flex align-items-center">
                                    <ng-container *ngIf="stageData">
                                        <span class="stage-label mr-2 {{ stageData.color }}"></span>
                                        <p class="m-0">{{ stageData.name }}</p>
                                    </ng-container>

                                    <p *ngIf="!stageData" class="m-0">No Stage</p>
                                </div>
                            </ng-container>

                            <h3 *ngIf="dataLoaded && (taskData.projectId === '' || taskData.projectId === null)"
                               class="form-label">
                                No Project
                            </h3>
                        </h3>

                        <h3 class="form-label">
                            {{ taskData.messageTitle | titlecase }}
                            <!--Taskuri venite din projects module-->
                            <div *ngIf="projectDataLoaded && projectId !== undefined" class="d-flex align-items-center">
                                <ng-container *ngIf="stageData">
                                    <span class="stage-label mr-2 {{ stageData.color }}"></span>
                                    <p class="m-0">{{ stageData.name }}</p>
                                </ng-container>

                                <p *ngIf="!stageData" class="m-0">No Stage</p>
                            </div>
                        </h3>
                    </div>

                    <!--Description-->
                    <div class="col-12 mb-8">
                        <h3 class="form-label">
                            Description
                        </h3>
                        <textarea readonly class="blue-scroll-bar mb-5 description-textarea"
                                  [placeholder]="(taskData.messageDetail === null || taskData.messageDetail.length === 0) ? 'No description' : ''"
                                  [value]="taskData.messageDetail">
                </textarea>
                    </div>
                </div>
            </div>

            <div class="col-12 col-xl-4 main-column">
                <div class="row">
                    <!--Task completion-->
                    <div *ngIf="dataLoaded && percentageLoaded"
                         class="col-12 mb-8 top-tile">
                        <h3 class="form-label">
                            Task Completion
                        </h3>

                        <div class="d-flex flex-column align-items-center justify-content-between project-completion">
                            <apx-chart #chart
                                    [series]="chartOptions.series"
                                    [chart]="chartOptions.chart"
                                    [xaxis]="chartOptions.xaxis"
                                    [yaxis]="chartOptions.yaxis"
                                    [dataLabels]="chartOptions.dataLabels"
                                    [stroke]="chartOptions.stroke"
                                    [legend]="chartOptions.legend"
                                    [fill]="chartOptions.fill"
                                    [states]="chartOptions.states"
                                    [tooltip]="chartOptions.tooltip"
                                    [colors]="chartOptions.colors"
                                    [markers]="chartOptions.markers"
                                    [plotOptions]="chartOptions.plotOptions"
                            ></apx-chart>
                            <p class="mb-8">Tasks completed</p>
                            <div class="progress mb-2">
                                <div class="progress-bar {{barClass}}" role="progressbar" style="width: {{progressBar}}%"></div>
                            </div>
                            <p class="m-0">Due date</p>
                            <span style="color: {{spanColor}}">{{taskData.deadline | date: 'd MMMM, y' }}</span>
                        </div>

                    </div>

                    <!--Task Member-->
                    <div class="col-12 members-list mb-8">
                        <div class="d-flex justify-content-between align-items-center mb-5">
                            <h3 class="form-label m-0">Assigned Member</h3>
                            <!--                    <button type="button" class="btn-default btn-green flex-row-reverse add-button"
                                                        (click)="openModal(addMember)">
                                                    <span translate="PROJECTS.MEMBER"></span>
                                                    <span class="fas fa-plus mr-3"></span>
                                                </button>-->

                            <!--                    <ng-template #addMember let-c="close">
                                                    <div class="modal-header">
                                                        <h3 class="modal-title" translate="PROJECTS.ADD_NEW_MEMBER"></h3>
                                                        <button type="button" class="btn-back" (click)="c()">
                                                            <span class="fa fa-arrow-left"></span>
                                                        </button>
                                                    </div>
                                                    <div class="modal-body modal-members">
                                                        <div *ngFor="let user of allUsersInfo" class="row align-items-center mb-4">
                                                            <div class="col-5 col-sm-4 d-flex align-items-center pr-0">
                                                                <img src="{{user.profileImagePath}}">
                                                                <p class="bold-text ml-3">{{user.firstName + ' ' + user.lastName}}</p>
                                                            </div>

                                                            <div class="col-5 col-sm-4 d-flex justify-content-center">
                                                                <p>{{ user.department === '' ? 'No Department' : user.department }}</p>
                                                            </div>

                                                            <div class="col-2 col-sm-4 d-flex justify-content-end">
                                                                <button type="button" class="btn-default btn-green add-member" (click)="addNewMember(user)">
                                                                    <span class="fas fa-plus"></span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ng-template>-->
                        </div>
                        <div *ngIf="userData !== undefined && userData !== null" class="row align-items-center mb-4">
                            <div class="col-10 d-flex align-items-center pr-0">
                                <img src="{{userData.profileImagePath}}">
                                <p class="bold-text ml-3">{{userData.firstName + ' ' + userData.lastName}}</p>
                            </div>

                            <div class="col-2 d-flex justify-content-end">
                                <p>{{ userData.department === '' ? 'No Department' : userData.department }}</p>
                            </div>

                        </div>
                        <div *ngIf="userData === undefined || userData === null">
                            <h3>No Member Assigned</h3>
                        </div>
                    </div>
                </div>
            </div>

            <!--Task checklist-->
            <div class="col-12 col-xl-4 main-column tasks-column top-tile">
                <h3 *ngIf="taskData.subtasks?.length > 0" class="form-label mb-4">Task Checklist:</h3>

                <div class="tasks-container blue-scroll-bar">
                    <div class="row d-flex justify-content-start align-items-center pl-4 pr-4 mb-4" *ngFor="let subTask of taskData.subtasks; let i = index">
                        <label class="task-label mb-0" [ngStyle]="{'cursor': isAllowedToEdit ? 'pointer' : 'not-allowed'}"
                               [ngClass]="isAllowedToEdit ? 'conditional-hover' : ''">
                            <input class="task-input d-none" type="checkbox"
                                   id="taskCheck"
                                   (change)="taskChecked(i)"
                                   [disabled]="!isAllowedToEdit"
                                   [checked]="subTask.solved">
                            <span class="task-checkbox"></span>
                        </label>
                        <p class="bold-text ml-3 mb-0">{{subTask.description}}</p>
                    </div>
                </div>

                <button *ngIf="isAllowedToEdit" type="button" class="mt-3 btn-default btn-mark-done"
                        (click)="taskDone()"
                        [ngClass]="taskData.status === 'completed' ? 'btn-green btn-unmark' : 'btn-red btn-completed'">
                    <span class="mr-3"
                          [ngClass]="taskData.status === 'completed' ? 'fas fa-check' : 'fas fa-times'"></span>
                    <span>
                        {{ taskData.status === 'completed' ? 'Completed' : 'Not Completed'}}
                    </span>
                </button>

            </div>

            <!--<div *ngIf="taskData.subtasks === null || taskData.subtasks.length === 0" class="col-12 col-xl-4 main-column top-tile">
                <div class="row d-flex justify-content-start align-items-center pl-4 mb-4">
                    <div class="d-flex done-checkbox">
                        <label class="task-label mb-0" for="markDone">
                            <input class="task-input d-none" type="checkbox"
                                   id="markDone"
                                   (change)="taskDone()"
                                   [checked]="taskData.status === 'completed' ? true : false">
                            <span class="task-checkbox"></span>
                        </label>
                        <p class="bold-text ml-3 mb-0">Mark as done</p>
                    </div>
                </div>
            </div>-->

        </div>
    </div>
</div>
